import profileDatashape from "src/app/shared/datashapes/profile.datashape";
export default `
  id
  email
  code
  mobile
  name
  createdAt
  surname
  enabled
  blacklisted
  mobileVerified
  emailVerified
  deleted
  rating
   profile {
    ${profileDatashape}
  }

`;
